<template>
    <div class="index clearfix">
        <img :src="imgHost + 'curtain-left.png'" alt="" class="curtain" style="left: 0;">
        <img :src="imgHost + 'curtain-right.png'" alt="" class="curtain" style="right: 0;">
        <div class="recruit">
            <img @click="goRouter({path: '/joinUs'})" :src="imgHost + 'recruit.png'" style="display: block;width: 80%;margin: 0 auto;min-width: 300px;max-width: 400px;padding-top: 50px;cursor:pointer;">
            <div class="downLoad" style="width: 80%;margin: 0 auto;min-width: 300px;max-width: 380px;">
                <img :src="imgHost + '1506749785.png'" style="display: block; width: 50%;margin: 30px auto;min-width: 120px;max-width: 180px">
                <span @click="openWindow('http://a.myapp.com/o/simple.jsp?pkgname=pinkdiary.xiaoxiaotu.com&g_f=991653')"  style="display: block;margin: 0 auto;width: 115px; padding: 10px 22px;background-color:#FF6C8C;border: 3px solid #FFFFFF;
border-radius: 26px;font-size: 14px;color: #FFFFFF;letter-spacing: 0;text-align: center;cursor:pointer;">
                        Download | 下载
                    </span>
            </div>
        </div>
        <footer>
            <div style="position:relative;width:100%;height: 190px;">
               <img class="a1" :src="imgHost + 'book.png'" alt="" style="">
                <img class="a2" :src="imgHost + 'coffee.png'" alt="" style="">
                <img class="a3" :src="imgHost + 'brushpot.png'" alt="" style="">
                <img class="a4" :src="imgHost + 'calendar.png'" alt="" style="">
                <img class="a5" :src="imgHost + 'iphone.png'" alt="" style="">
                <img class="a8" :src="imgHost + 'cat.png'" alt="" style="">
                <img class="a9" :src="imgHost + 'cactus.png'" alt="" style="">
                <img class="a10" :src="imgHost + 'picture.png'" alt="" style="">
            </div>
            <div style="height: 60px;line-height: 60px">
                <div class="" style="width: 960px;height: 100%; margin: 0 auto;font-size: 14px;color: #FFFFFF;letter-spacing: 0;line-height: 60px;">
                    <ul class="fl" style="height: 100%;">
                        <li class="fl" style="height: 100%;margin-right: 20px;">上海盘隆科技有限公司</li>
                        <li class="fl" style="height: 100%;margin-right: 20px;">粉粉日记©2012-2019</li>
                        <li class="fl" style="height: 100%;"><a href="http://www.miitbeian.gov.cn" target="_blank" style="font-size: 14px;color: #FFFFFF;letter-spacing: 0;height: 22px;line-height: 22px;margin-top: 19px;">沪ICP备12018816号-1</a></li>
                    </ul>
                    <div class="fr">
                        <span style="cursor:pointer;" @click="goRouter({path: '/joinUs'})">加入我们</span>
                        <span>-</span>
                        <span style="cursor:pointer;" @click="goRouter({path: '/privacy'})">粉粉协议</span>
                        <span>-</span>
                        <span style="cursor:pointer;" @click="goRouter({path: '/help'})">帮助</span>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                msg: 'message'
            }
        },
        methods: {
            goRouter: function (data) {
                this.$router.push(data)
            }
        },
        created: function () {
            trackEvent('visitIndex')
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/pages/index.vue